
/*
  This component will display steps in configurator
 */

import React, {useEffect, useState} from 'react'
import Select from '../common_elements/Select'
import Radio from '../common_elements/Radio'
import {  useSelector, useDispatch } from "react-redux";
import ExceptionMessage from "../common_elements/ExceptionMessage";
import { productSelectionChanged } from "../../store/product/productSelectionsSlice";
import {
    addElementToUpdateModules,
    removeElementToUpdateModules,
    shouldUpdateModulesSet
} from "../../store/configuratorStateSlice";
import {updateElementSelection} from "../../store/product/productElementsSlice";

const ElementAttributeStep = (props) => {

    const dispatch = useDispatch();
    const disabledFields = useSelector(state => state.disabledFieldsReducer.disabledElementFields);
    const errorFields = useSelector(state => state.configuratorStateReducer.errorFields);
    const shouldIgnoreExceptionFields = useSelector(state => state.configuratorStateReducer.lockedFieldsIgnoringDisabled);
    const elementsShowingHidden = useSelector(state => state.configuratorStateReducer.elementsShowingHidden);
    const [showException, setShowException] = useState(false);
    const [messages, setMessages] = useState([]);
    const [exceptionLeft, setExceptionLeft] = useState(0);

    // this generates unique key, used for radiobutton group
    const generateKey = () => {
        return `configurator_attribute_${props.attributes.id}_${ new Date().getTime() }`;
    }
    // run single choice on mount
    useEffect(() =>{
        selectIfSingleChoice();
    }, []);

    const handleDisabledClick = (e) => {
        setShowException(true);
        const mouseX = e.pageX;
        // setup the exception message as well
        const fieldList = disabledFields[props.elementKey] ? disabledFields[props.elementKey] : []
        const matchingField = fieldList.find(obj => obj.field == props.attributes.name);
        const message = matchingField ? matchingField.messages:"";
        setExceptionLeft(mouseX);
        setMessages(message);

    };

    const selectIfSingleChoice = () => {
        // this will auto select the attribute if there is only 1 possible selection
        //and there is no current selection
        const selections = props.attributes.values.split(",");
        const disabledSelections = getDisabledSelections();
        if(selections.length - disabledSelections.length == 1 && !props.attributes.selection){
            const selectionToMake = selections.find(sel => !disabledSelections.includes(sel))
            dispatch(updateElementSelection(props.elementKey, props.attributes, selectionToMake))
        }

    }

    const isErrorField = () => {

        const errorField = errorFields.includes(props.attributes.id.toString());
        if(errorField){
            dispatch(productSelectionChanged(props.attributes, ""))
        }
        return errorField
    }

    const getDisabledSelections = () => {
        if(disabledFields == null || disabledFields[props.elementKey] == null ){
            return  [];
        }
        const matchingField = disabledFields[props.elementKey].find(obj => obj.field == props.attributes.name);
        return matchingField ? matchingField.disabledSelections : [];
    };

    const ignoreDisabledFields = () => {
        return shouldIgnoreExceptionFields.includes(props.attributes.id)
    }

    // this piece of code determine wether we render a select box for attribute or a radio button
    const radioOrSelect = () => {
        let values = props.attributes.values;
        let value = props.currentValue == "" ? undefined : props.currentValue;
        if (values.length > 5) {
            return (
                <label title={messages ? messages.join(', '):""}>
                    <Select key={props.attributes.id + "-" + props.index + "-" + value + isErrorField() }
                            attributes={props.attributes}
                            propType={'ATTRIBUTE'}
                            currentValue={value}
                            fieldId={props.attributes.sku_order}
                            disabledSelections={getDisabledSelections()}
                            ignoreDisabled={ignoreDisabledFields()}
                            hasEmptyField={props.currentValue == null || props.currentValue == ""}
                            onClick={(e) => handleDisabledClick(e)}
                            onChange={() => hideExceptionMessage()}
                            handleAttribute={handleElementAttribute}
                            errorField={isErrorField()}
                            disabled={props.disabled}
                    />
                </label>)
        } else {
            return  (
                <label title={messages ? messages.join(', '):""}>
                    <Radio key={props.attributes.id + "-" + props.index + "-" + value}
                           attributes={props.attributes}
                           propType={'ATTRIBUTE'}
                           currentValue={value}
                           group={generateKey()}
                           checkType={'radio'}
                           fieldId={props.attributes.sku_order}
                           disabledSelections={ getDisabledSelections()  }
                           ignoreDisabled={ignoreDisabledFields()}
                           onChange={() => hideExceptionMessage()}
                           onClick={(e) => handleDisabledClick(e)}
                           handleAttribute={handleElementAttribute}
                           errorField={isErrorField()}
                           disabled={props.disabled}
                    />
                </label>
            )

        }
    }

    const exceptionMessage = () => {
        if(!showException || messages.length == 0 ) {
            return;
        }

        return <ExceptionMessage message={messages} posLeft={exceptionLeft}/>
    }

    const visibility = () => {
        /* this is a bit confusing so here are the business rules:
            1. For non Pattern:
             - Version is hidden and pre-filled if user is not an admin
             - Version is not hidden when user is an admin
            2. For Patterns:
              - Version is always hidden and pre-filled

            This logic is currently handled on the backend, the value
            being passed to preselected
        */
        if (props.attributes.read_only || props.attributes.preselected || (props.attributes.hidden && !elementsShowingHidden.includes(props.elementKey))) {
            return {display: 'none'};
        }
    }
    const shouldHideException = (type) => {
        // here we see if we should hide the exception message based on type
        // radio buttons should hide on mouse leave, where selects should hide
        // on focus leave.  We look at values to determine whether the field matches
        // the type - this is to allow radio to hide on click, and leave selects hiding
        // on blur
        if(type == 'select'){
            if( props.attributes.values.length > 5){
                hideExceptionMessage()
            }
        } else {
            if( props.attributes.values.length <= 5){
                hideExceptionMessage()
            }
        }
    }

    const hideExceptionMessage = () => {
        setMessages([]);
        setShowException(false);
    }

    const handleElementAttribute = (value) => {
        // only update modules when length changes
        if(props.attributes.internal_name == "length" || props.attributes.internal_name == "ceiling") {
            dispatch(addElementToUpdateModules(props.elementKey))
        }else {
            dispatch(removeElementToUpdateModules(props.elementKey))
        }
        dispatch(updateElementSelection(props.elementKey, props.attributes, value));
        
    }


    return (
        <div key={'attribute-selection-' + props.currentValue} style={{position: 'relative'}}>
            <div className="configurator-step" style={visibility()} onMouseLeave={() => shouldHideException('radio')} onBlur={() => shouldHideException('select')}>
                <div className="row flex-row">
                    <div className="title small-12 medium-2 columns">
                        <h3>{props.attributes.name}</h3>
                    </div>
                    <div className="selection small-12 medium-10 columns">
                        <fieldset>
                            {radioOrSelect()}
                        </fieldset>
                    </div>
                </div>
            </div>
            { exceptionMessage() }
        </div>
    )
}

export default ElementAttributeStep;
